<template>
  <v-container 
    class="d-flex justify-center align-center" 
    style="height: 100vh;"
  >
    <v-row class="justify-center align-center ">
      <v-col cols="auto">
        <AuthCard/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import AuthCard from '../components/AuthCard.vue';

export default {
    components: {
        AuthCard
    }
}

</script>